(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"]) return;
  try {
    
  function prefillContactVehicle(scope) {
    const vehicle = new URLSearchParams(window.location.search).get('vehicle');
    if (!vehicle || !vehicle.trim()) return;
    scope.querySelectorAll('input[name="contact[vehicle]"]').forEach((field) => {
      if (field.dataset.vehiclePrefillReady === 'true') return;
      field.dataset.vehiclePrefillReady = 'true';
      if (field.value === '') field.value = vehicle;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prefillContactVehicle(document));
  } else {
    prefillContactVehicle(document);
  }
  document.addEventListener('shopify:section:load', (event) => prefillContactVehicle(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-gallery-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-gallery-page]';

  function initGalleryPage(root) {
    if (!root || root.dataset.galleryPageReady === 'true') return;
    root.dataset.galleryPageReady = 'true';

    const triggers = Array.from(root.querySelectorAll('[data-gallery-open]'));
    const dialog = root.querySelector('[data-gallery-dialog]');
    const image = dialog?.querySelector('[data-gallery-image]');
    const caption = dialog?.querySelector('[data-gallery-caption]');
    const counter = dialog?.querySelector('[data-gallery-counter]');
    if (!dialog || !image || triggers.length === 0) return;

    let currentIndex = 0;
    let returnFocus = null;
    let touchStartX = 0;
    let touchStartY = 0;

    function render(index) {
      currentIndex = (index + triggers.length) % triggers.length;
      const trigger = triggers[currentIndex];
      image.width = Number(trigger.dataset.galleryWidth);
      image.height = Number(trigger.dataset.galleryHeight);
      image.src = trigger.dataset.galleryFull;
      image.alt = trigger.dataset.galleryAlt || '';
      caption.textContent = trigger.dataset.galleryCaption || '';
      caption.hidden = !caption.textContent;
      counter.textContent = `${currentIndex + 1} / ${triggers.length}`;
    }

    function open(index, trigger) {
      returnFocus = trigger;
      render(index);
      document.body.classList.add('gallery-lightbox-open');
      dialog.showModal();
      dialog.querySelector('[data-gallery-close]')?.focus();
    }

    function close() {
      if (!dialog.open) return;
      dialog.close();
    }

    triggers.forEach((trigger, index) => trigger.addEventListener('click', () => open(index, trigger)));
    dialog.querySelector('[data-gallery-close]')?.addEventListener('click', close);
    dialog.querySelector('[data-gallery-previous]')?.addEventListener('click', () => render(currentIndex - 1));
    dialog.querySelector('[data-gallery-next]')?.addEventListener('click', () => render(currentIndex + 1));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('gallery-lightbox-open');
      image.removeAttribute('src');
      if (returnFocus && document.contains(returnFocus)) returnFocus.focus();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        render(currentIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        render(currentIndex + 1);
      }
    });
    dialog.addEventListener('touchstart', (event) => {
      const touch = event.changedTouches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    }, { passive: true });
    dialog.addEventListener('touchend', (event) => {
      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;
      if (Math.abs(deltaX) > 55 && Math.abs(deltaX) > Math.abs(deltaY)) render(currentIndex + (deltaX < 0 ? 1 : -1));
    }, { passive: true });
  }

  function initAll(scope) {
    if (scope.matches && scope.matches(selector)) initGalleryPage(scope);
    scope.querySelectorAll(selector).forEach(initGalleryPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-customer-gallery]';
  const resumeDelay = 3000;

  function initGallery(root) {
    if (!root || root.dataset.galleryReady === 'true') return;
    root.dataset.galleryReady = 'true';

    const viewport = root.querySelector('[data-gallery-viewport]');
    const track = root.querySelector('[data-gallery-track]');
    if (!viewport || !track) return;
    const speed = Number(root.dataset.gallerySpeed) || 18;

    const originals = Array.from(track.querySelectorAll('[data-gallery-card]'));
    if (originals.length < 2) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let cycleWidth = 0;
    let baseOffset = 0;
    let frame = 0;
    let lastTime = performance.now();
    let resumeAt = lastTime + 800;
    let scrollRemainder = 0;
    let dragging = false;
    let dragStartX = 0;
    let dragStartScroll = 0;
    let gesturePointer = null;
    let gestureStartX = 0;
    let gestureStartY = 0;
    let horizontalGesture = false;
    let resizeTimer = 0;

    function cloneCard(card) {
      const clone = card.cloneNode(true);
      clone.dataset.galleryClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
      clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => element.removeAttribute('data-shopify-editor-block'));
      clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach((element) => element.setAttribute('tabindex', '-1'));
      return clone;
    }

    function appendCloneSet(fragment) {
      originals.forEach((card) => fragment.appendChild(cloneCard(card)));
    }

    function normalizePosition() {
      if (!cycleWidth) return;
      if (viewport.scrollLeft >= baseOffset + cycleWidth) viewport.scrollLeft -= cycleWidth;
      if (viewport.scrollLeft < baseOffset - cycleWidth) viewport.scrollLeft += cycleWidth;
    }

    function buildLoop() {
      track.querySelectorAll('[data-gallery-clone]').forEach((clone) => clone.remove());
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const first = originals[0];
      const last = originals[originals.length - 1];
      cycleWidth = last.offsetLeft + last.offsetWidth + gap - first.offsetLeft;
      if (!cycleWidth) return;

      const copies = Math.ceil(viewport.clientWidth / cycleWidth) + 1;
      const before = document.createDocumentFragment();
      const after = document.createDocumentFragment();
      for (let index = 0; index < copies; index += 1) {
        appendCloneSet(before);
        appendCloneSet(after);
      }
      track.insertBefore(before, originals[0]);
      track.appendChild(after);
      baseOffset = originals[0].offsetLeft;
      viewport.scrollLeft = baseOffset;
      scrollRemainder = 0;
      resumeAt = performance.now() + 800;
    }

    function pause(delay = resumeDelay) {
      resumeAt = performance.now() + delay;
      viewport.classList.remove('is-auto-moving');
    }

    function tick(time) {
      const elapsed = Math.min((time - lastTime) / 1000, 1);
      lastTime = time;
      const paused = reducedMotion.matches || document.hidden || dragging || time < resumeAt;
      if (!paused && cycleWidth) {
        viewport.classList.add('is-auto-moving');
        const distance = speed * elapsed + scrollRemainder;
        const previousPosition = viewport.scrollLeft;
        viewport.scrollLeft = previousPosition + distance;
        scrollRemainder = distance - (viewport.scrollLeft - previousPosition);
        normalizePosition();
      } else {
        viewport.classList.remove('is-auto-moving');
      }
      frame = requestAnimationFrame(tick);
    }

    function endPointer(event) {
      if (dragging) {
        dragging = false;
        viewport.classList.remove('is-dragging');
        if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
        pause();
      }
      if (event.pointerId === gesturePointer) {
        if (horizontalGesture) pause();
        gesturePointer = null;
        horizontalGesture = false;
      }
    }

    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button === 0) {
        pause();
        scrollRemainder = 0;
        dragging = true;
        dragStartX = event.clientX;
        dragStartScroll = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(event.pointerId);
        event.preventDefault();
      } else {
        gesturePointer = event.pointerId;
        gestureStartX = event.clientX;
        gestureStartY = event.clientY;
        horizontalGesture = false;
      }
    });
    viewport.addEventListener('pointermove', (event) => {
      if (dragging) {
        viewport.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
        normalizePosition();
        return;
      }
      if (event.pointerId !== gesturePointer) return;
      const deltaX = Math.abs(event.clientX - gestureStartX);
      const deltaY = Math.abs(event.clientY - gestureStartY);
      if (deltaX > 8 && deltaX > deltaY) horizontalGesture = true;
      if (horizontalGesture) {
        scrollRemainder = 0;
        pause();
      }
    });
    viewport.addEventListener('pointerup', endPointer);
    viewport.addEventListener('pointercancel', endPointer);
    viewport.addEventListener('wheel', (event) => {
      if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
        scrollRemainder = 0;
        pause();
      }
    }, { passive: true });
    viewport.addEventListener('scroll', normalizePosition, { passive: true });
    viewport.addEventListener('keydown', (event) => {
      if (['ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown', ' '].includes(event.key)) pause();
    });

    const resizeObserver = new ResizeObserver(() => {
      clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(buildLoop, 200);
    });
    resizeObserver.observe(viewport);
    reducedMotion.addEventListener('change', pause);
    buildLoop();
    frame = requestAnimationFrame(tick);

    root.galleryCleanup = () => {
      cancelAnimationFrame(frame);
      clearTimeout(resizeTimer);
      resizeObserver.disconnect();
      reducedMotion.removeEventListener('change', pause);
    };
  }

  function initAll(scope) {
    if (scope.matches && scope.matches(selector)) initGallery(scope);
    scope.querySelectorAll(selector).forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches(selector) ? event.target : event.target.querySelector(selector);
    if (root && root.galleryCleanup) root.galleryCleanup();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart-form]').forEach((form)=>{
    const status=form.querySelector('[data-cart-status]');
    const update=form.querySelector('[data-cart-update]');
    const setChanged=()=>{if(status)status.textContent=form.dataset.quantityChanged;if(update)update.dataset.changed='true'};
    form.addEventListener('click',(event)=>{const control=event.target.closest('[data-quantity-change]');if(!control)return;const input=control.parentElement.querySelector('[data-cart-quantity]');if(!input)return;input.value=String(Math.max(0,Number(input.value||0)+Number(control.dataset.quantityChange||0)));input.dispatchEvent(new Event('change',{bubbles:true}))});
    form.querySelectorAll('[data-cart-quantity]').forEach((input)=>input.addEventListener('change',setChanged));
    form.querySelectorAll('[data-cart-remove]').forEach((link)=>link.addEventListener('click',()=>{if(status)status.textContent=form.dataset.removingItem}));
    form.addEventListener('submit',(event)=>{if(status)status.textContent=event.submitter?.name==='checkout'?form.dataset.secureCheckout:form.dataset.updatingCart;if(event.submitter)event.submitter.setAttribute('aria-busy','true')});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (()=>{
    const syncShoppingDirectoryView=()=>{
      document.querySelectorAll('.shopping-directory').forEach((directory)=>{
        const intro=directory.querySelector('[data-shopping-directory-intro]');
        const tops=directory.querySelector('#convertible-tops');
        if(!intro||!tops)return;
        const topsView=window.location.hash==='#convertible-tops';
        intro.hidden=topsView;
        directory.classList.toggle('is-convertible-tops-view',topsView);
      });
    };
    syncShoppingDirectoryView();
    window.addEventListener('hashchange',syncShoppingDirectoryView);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!window.megakronProductNavigation) {
    window.megakronProductNavigation = true;
    let request;
    let ownsFrame = false;
    let purchaseObserver;

    const setupProduct = (root) => {
      const owned = root.querySelector('[data-frame-owned]');
      if (owned) {
        owned.checked = ownsFrame;
        const offer = root.querySelector('[data-frame-offer]');
        const intro = root.querySelector('[data-frame-intro]');
        const ownedCopy = root.querySelector('[data-frame-owned-copy]');
        if (offer) offer.hidden = ownsFrame;
        if (intro) intro.hidden = ownsFrame;
        if (ownedCopy) ownedCopy.hidden = !ownsFrame;
      }
      purchaseObserver?.disconnect();
      const primary = root.querySelector('[data-primary-add]');
      const mobile = root.querySelector('[data-mobile-purchase]');
      if (primary && mobile && 'IntersectionObserver' in window) {
        purchaseObserver = new IntersectionObserver(([entry]) => {
          mobile.hidden = entry.isIntersecting;
          mobile.classList.toggle('is-ready', !entry.isIntersecting);
        }, { threshold: 0.05 });
        purchaseObserver.observe(primary);
      }
    };

    document.addEventListener('change', (event) => {
      if (!event.target.matches('[data-frame-owned]')) return;
      ownsFrame = event.target.checked;
      const frame = event.target.closest('.optional-frame');
      const offer = frame?.querySelector('[data-frame-offer]');
      const intro = frame?.querySelector('[data-frame-intro]');
      const ownedCopy = frame?.querySelector('[data-frame-owned-copy]');
      if (offer) offer.hidden = ownsFrame;
      if (intro) intro.hidden = ownsFrame;
      if (ownedCopy) ownedCopy.hidden = !ownsFrame;
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const details = event.target.closest('.option-help[open]');
      if (!details) return;
      details.open = false;
      details.querySelector('summary')?.focus();
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-product-form]');
      if (!form || !window.megakronCart) return;
      event.preventDefault();
      window.megakronCart.add(form, event.submitter);
    });

    document.addEventListener('click', async (event) => {
      document.querySelectorAll('.option-help[open]').forEach((details) => {
        if (!details.contains(event.target)) details.open = false;
      });

      const thumbnail = event.target.closest('[data-gallery-thumb]');
      if (thumbnail) {
        const root = thumbnail.closest('[data-product-section]');
        const main = root?.querySelector('.product-featured');
        if (main) {
          const selectedImage = thumbnail.querySelector('[data-gallery-image]')?.content.querySelector('img');
          if (selectedImage) {
            ['sizes', 'srcset', 'width', 'height'].forEach((attribute) => {
              const value = selectedImage.getAttribute(attribute);
              if (value !== null) main.setAttribute(attribute, value);
              else main.removeAttribute(attribute);
            });
          }
          main.src = thumbnail.dataset.imageSrc;
          main.alt = thumbnail.dataset.imageAlt || '';
          root.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
            const active = button === thumbnail;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
          });
        }
        return;
      }

      const mobileAdd = event.target.closest('[data-mobile-add]');
      if (mobileAdd) {
        mobileAdd.closest('[data-product-section]')?.querySelector('.product-form')?.requestSubmit();
        return;
      }

      const link = event.target.closest('[data-option-link]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const root = link.closest('[data-product-section]');
      if (!root || root.getAttribute('aria-busy') === 'true') return;
      event.preventDefault();
      request?.abort();
      request = new AbortController();
      root.setAttribute('aria-busy', 'true');
      root.querySelectorAll('button[name="add"]').forEach((button) => { button.disabled = true; });
      const url = new URL(link.href);
      const fetchUrl = new URL(url);
      fetchUrl.searchParams.set('section_id', root.id.replace('Product-', ''));
      const optionPosition = link.closest('[data-option-disclosure]')?.querySelector('[data-option-summary]')?.dataset.optionSummary;
      try {
        const response = await fetch(fetchUrl, { signal: request.signal });
        if (!response.ok) throw new Error('Variant fetch failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = html.getElementById(root.id);
        if (!next) throw new Error('Product section missing');
        const focusKey = link.dataset.focusKey;
        root.replaceWith(next);
        history.replaceState({}, '', url);
        setupProduct(next);
        if (optionPosition) {
          next.querySelector('[data-option-summary="' + CSS.escape(optionPosition) + '"]')?.focus({ preventScroll: true });
        } else {
          next.querySelector('[data-focus-key="' + CSS.escape(focusKey) + '"]')?.focus({ preventScroll: true });
        }
      } catch (error) {
        if (error.name !== 'AbortError') window.location.assign(url);
      }
    });

    document.querySelectorAll('[data-product-section]').forEach(setupProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
  document.querySelectorAll('[data-site-header]').forEach((header)=>{
    const button=header.querySelector('.menu-toggle');
    const nav=header.querySelector('.primary-nav');
    button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!open));nav.classList.toggle('is-open',!open)});
    header.addEventListener('toggle',(event)=>{if(!event.target.matches('.nav-dropdown')||!event.target.open)return;header.querySelectorAll('.nav-dropdown[open]').forEach((item)=>{if(item!==event.target)item.removeAttribute('open')})},true);
    document.addEventListener('click',(event)=>{if(header.contains(event.target))return;header.querySelectorAll('.nav-dropdown[open]').forEach((item)=>item.removeAttribute('open'))});
    header.addEventListener('keydown',(event)=>{if(event.key!=='Escape')return;header.querySelectorAll('.nav-dropdown[open]').forEach((item)=>item.removeAttribute('open'));nav.classList.remove('is-open');button.setAttribute('aria-expanded','false');button.focus()});
  });
  if (!window.megakronCart) {
    const notice=document.querySelector('[data-cart-notice]');
    const message=notice?.querySelector('[data-cart-notice-message]');
    const itemView=notice?.querySelector('[data-cart-notice-item]');
    const itemImage=notice?.querySelector('[data-cart-notice-image]');
    const itemPlaceholder=notice?.querySelector('[data-cart-notice-placeholder]');
    const itemLinks=notice?.querySelectorAll('[data-cart-notice-product-link],[data-cart-notice-title]');
    const itemTitle=notice?.querySelector('[data-cart-notice-title]');
    const itemOptions=notice?.querySelector('[data-cart-notice-options]');
    const itemQuantity=notice?.querySelector('[data-cart-notice-quantity]');
    const itemPrice=notice?.querySelector('[data-cart-notice-price]');
    const subtotal=notice?.querySelector('[data-cart-notice-subtotal] strong');
    const miniCart=document.querySelector('[data-mini-cart]');
    const miniPanel=miniCart?.querySelector('.mini-cart__panel');
    const miniBody=miniCart?.querySelector('[data-mini-cart-body]');
    const miniEmpty=miniCart?.querySelector('[data-mini-cart-empty]');
    const miniFooter=miniCart?.querySelector('[data-mini-cart-footer]');
    const miniFallback=miniCart?.querySelector('[data-mini-cart-fallback]');
    const miniStatus=miniCart?.querySelector('[data-mini-cart-status]');
    const miniCount=miniCart?.querySelector('[data-mini-cart-count]');
    const miniSubtotal=miniCart?.querySelector('[data-mini-cart-subtotal]');
    const miniSavings=miniCart?.querySelector('[data-mini-cart-savings]');
    const miniTriggers=document.querySelectorAll('[data-mini-cart-trigger]');
    let miniBusy=false;
    let miniTrigger=null;
    const formatMoney=(cents)=>{
      const value=Number(cents||0)/100;
      try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:notice?.dataset.currency||miniCart?.dataset.currency||'USD'}).format(value)}catch(error){return '$'+value.toFixed(2)}
    };
    const meaningfulOptions=(item)=>Array.isArray(item?.options_with_values)?item.options_with_values.filter((option)=>option?.value&&option.value!=='Default Title'&&option.name!=='Title'):[];
    const placeholderLabel=(item)=>{
      const values=meaningfulOptions(item).map((option)=>option.value);
      if(values.length)return values.join(' · ');
      if(item?.variant_title&&item.variant_title!=='Default Title')return item.variant_title;
      return item?.product_title||item?.title||'';
    };
    const updateCartCounts=(count)=>document.querySelectorAll('[data-cart-count]').forEach((element)=>{element.textContent=' ('+count+')';element.hidden=count===0});
    const renderItem=(item,cart,addedQuantity)=>{
      if(!notice||!item)return;
      const productTitle=item.product_title||item.title||'';
      const productUrl=item.url||'#';
      itemLinks?.forEach((link)=>{link.href=productUrl});
      if(itemTitle)itemTitle.textContent=productTitle;
      const imageUrl=item.featured_image?.url||item.image||'';
      if(itemImage){itemImage.hidden=!imageUrl;if(imageUrl){itemImage.src=imageUrl;itemImage.alt=item.featured_image?.alt||productTitle}}
      const options=meaningfulOptions(item);
      if(itemPlaceholder){itemPlaceholder.textContent=placeholderLabel(item);itemPlaceholder.hidden=Boolean(imageUrl)}
      if(itemOptions){
        itemOptions.replaceChildren();
        options.forEach((option)=>{
          if(!option?.value||option.value==='Default Title'||option.name==='Title')return;
          const row=document.createElement('li');
          row.textContent=option.name+': '+option.value;
          itemOptions.append(row);
        });
        if(!itemOptions.children.length&&item.variant_title&&item.variant_title!=='Default Title'){
          const row=document.createElement('li');
          row.textContent=item.variant_title;
          itemOptions.append(row);
        }
      }
      const quantity=Number(addedQuantity||item.quantity||1);
      if(itemQuantity)itemQuantity.textContent=(notice.dataset.quantityLabel||'Quantity: __QUANTITY__').replace('__QUANTITY__',String(quantity));
      const unitPrice=item.final_price??item.price;
      const linePrice=unitPrice!=null?unitPrice*quantity:(item.final_line_price??item.line_price??0);
      if(itemPrice)itemPrice.textContent=formatMoney(linePrice);
      if(subtotal)subtotal.textContent=formatMoney(cart?.total_price);
      if(itemView)itemView.hidden=false;
    };
    const showNotice=(text,error=false,item=null,cart=null,addedQuantity=null)=>{
      if(!notice||!message)return;
      message.textContent=text;
      notice.classList.toggle('is-error',error);
      if(!error)renderItem(item,cart,addedQuantity);
      notice.hidden=false;
    };
    window.megakronCart={
      async add(form,button){
        if(!form||form.dataset.cartBusy==='true')return false;
        form.dataset.cartBusy='true';
        const submitter=button||form.querySelector('[type="submit"]');
        if(submitter)submitter.disabled=true;
        try{
          const root=window.Shopify?.routes?.root||'/';
          const formData=new FormData(form);
          const addedQuantity=Math.max(1,Number(formData.get('quantity')||1));
          const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:formData});
          const result=await response.json();
          if(!response.ok)throw new Error(result.description||result.message||form.dataset.cartError);
          const cartResponse=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});
          const cart=await cartResponse.json();
          updateCartCounts(cart.item_count);
          showNotice(form.dataset.cartSuccess||notice?.dataset.defaultSuccess,false,result,cart,addedQuantity);
          document.dispatchEvent(new CustomEvent('megakron:cart-added',{detail:{item:result,cart}}));
          return true;
        }catch(error){
          showNotice(error.message||form.dataset.cartError||notice?.dataset.defaultError,true);
          return false;
        }finally{
          form.dataset.cartBusy='false';
          if(submitter)submitter.disabled=false;
        }
      }
    };
    const closeNotice=()=>{if(notice)notice.hidden=true};
    const createElement=(tag,className,text)=>{const element=document.createElement(tag);if(className)element.className=className;if(text!==undefined)element.textContent=text;return element};
    const createDefinitionList=(rows,className)=>{
      if(!rows.length)return null;
      const list=createElement('dl',className);
      rows.forEach(([name,value])=>{const row=createElement('div');const term=createElement('dt','',name+':');const description=createElement('dd','',String(value));row.append(term,description);list.append(row)});
      return list;
    };
    const publicProperties=(item)=>{
      const entries=Array.isArray(item?.properties)?item.properties:Object.entries(item?.properties||{});
      return entries.filter(([name,value])=>name&&name.charAt(0)!=='_'&&value!==null&&value!==undefined&&String(value).trim()!=='');
    };
    const renderMiniLine=(item,index)=>{
      const productTitle=item.product_title||item.title||'';
      const productUrl=item.url||'#';
      const line=createElement('article','mini-cart-line');
      line.dataset.lineKey=item.key||String(index+1);
      const media=createElement('a','mini-cart-line__media');
      media.href=productUrl;
      media.setAttribute('aria-label',productTitle);
      const imageUrl=item.featured_image?.url||item.image||'';
      if(imageUrl){const image=createElement('img');image.src=imageUrl;image.alt=item.featured_image?.alt||productTitle;image.width=164;image.height=164;image.loading='lazy';media.append(image)}
      else{media.append(createElement('span','mini-cart-line__placeholder',placeholderLabel(item)))}
      const details=createElement('div','mini-cart-line__details');
      const title=createElement('a','mini-cart-line__title',productTitle);
      title.href=productUrl;
      details.append(title);
      const optionList=createDefinitionList(meaningfulOptions(item).map((option)=>[option.name,option.value]),'mini-cart-line__options');
      if(optionList)details.append(optionList);
      const propertyList=createDefinitionList(publicProperties(item),'mini-cart-line__properties');
      if(propertyList)details.append(propertyList);
      const allocations=Array.isArray(item.line_level_discount_allocations)?item.line_level_discount_allocations:[];
      if(allocations.length){
        const discounts=createElement('ul','mini-cart-line__discounts');
        allocations.forEach((allocation)=>{const label=allocation.discount_application?.title||allocation.title||'';discounts.append(createElement('li','',label+(label?' · ':'')+'−'+formatMoney(allocation.amount||0)))});
        details.append(discounts);
      }
      const bottom=createElement('div','mini-cart-line__bottom');
      const controls=createElement('div','mini-cart-line__controls');
      const quantity=createElement('div','mini-cart-quantity');
      const decrease=createElement('button','','−');
      decrease.type='button';decrease.dataset.miniCartQuantityChange='-1';decrease.dataset.miniCartControl='';decrease.setAttribute('aria-label',(miniCart.dataset.decreaseLabel||'').replace('__PRODUCT__',productTitle));
      const input=createElement('input');
      input.type='number';input.min='0';input.inputMode='numeric';input.value=String(item.quantity||0);input.dataset.currentQuantity=String(item.quantity||0);input.dataset.miniCartQuantity='';input.dataset.miniCartControl='';input.setAttribute('aria-label',(miniCart.dataset.quantityLabel||'Quantity')+': '+productTitle);
      const increase=createElement('button','','+');
      increase.type='button';increase.dataset.miniCartQuantityChange='1';increase.dataset.miniCartControl='';increase.setAttribute('aria-label',(miniCart.dataset.increaseLabel||'').replace('__PRODUCT__',productTitle));
      quantity.append(decrease,input,increase);
      const remove=createElement('button','mini-cart-line__remove',miniCart.dataset.removeLabel||'Remove');
      remove.type='button';remove.dataset.miniCartRemove='';remove.dataset.miniCartControl='';remove.setAttribute('aria-label',(miniCart.dataset.removeLabel||'Remove')+': '+productTitle);
      controls.append(quantity,remove);
      const price=createElement('div','mini-cart-line__price');
      if(item.original_line_price!==item.final_line_price)price.append(createElement('s','',formatMoney(item.original_line_price)));
      price.append(createElement('strong','',formatMoney(item.final_line_price)));
      bottom.append(controls,price);
      details.append(bottom);
      line.append(media,details);
      return line;
    };
    const renderMiniCart=(cart)=>{
      if(!miniCart||!miniBody)return;
      miniBody.replaceChildren();
      if(miniCount)miniCount.textContent='('+(cart.item_count||0)+')';
      if(miniFallback)miniFallback.hidden=true;
      const items=Array.isArray(cart.items)?cart.items:[];
      items.forEach((item,index)=>miniBody.append(renderMiniLine(item,index)));
      const empty=items.length===0;
      miniBody.hidden=empty;
      if(miniEmpty)miniEmpty.hidden=!empty;
      if(miniFooter)miniFooter.hidden=empty;
      if(miniSubtotal)miniSubtotal.textContent=formatMoney(cart.total_price||0);
      if(miniSavings){const savings=Number(cart.total_discount||0);miniSavings.hidden=savings<=0;const value=miniSavings.querySelector('strong');if(value)value.textContent='−'+formatMoney(savings)}
    };
    const setMiniStatus=(text)=>{if(miniStatus)miniStatus.textContent=text||''};
    const setMiniBusy=(busy)=>{miniBusy=busy;if(miniCart){miniCart.toggleAttribute('aria-busy',busy);miniCart.querySelectorAll('[data-mini-cart-control]').forEach((control)=>{control.disabled=busy})}};
    const closeMiniCart=(returnFocus=true)=>{
      if(!miniCart||miniCart.hidden)return;
      miniCart.hidden=true;
      document.documentElement.classList.remove('mini-cart-open');
      miniTriggers.forEach((trigger)=>trigger.setAttribute('aria-expanded','false'));
      if(returnFocus&&miniTrigger?.isConnected)miniTrigger.focus();
    };
    const fetchCart=async()=>{
      const root=window.Shopify?.routes?.root||'/';
      const response=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});
      const cart=await response.json();
      if(!response.ok)throw new Error(cart.description||cart.message||miniCart?.dataset.error);
      return cart;
    };
    const openMiniCart=async(trigger)=>{
      if(!miniCart||!miniPanel)return;
      miniTrigger=trigger;
      closeNotice();
      miniCart.hidden=false;
      document.documentElement.classList.add('mini-cart-open');
      miniTriggers.forEach((item)=>item.setAttribute('aria-expanded','true'));
      if(miniEmpty)miniEmpty.hidden=true;
      if(miniFooter)miniFooter.hidden=true;
      if(miniFallback)miniFallback.hidden=true;
      if(miniBody)miniBody.replaceChildren();
      setMiniStatus(miniCart.dataset.loading);
      miniCart.querySelector('.mini-cart__close')?.focus();
      try{const cart=await fetchCart();renderMiniCart(cart);updateCartCounts(cart.item_count);setMiniStatus('')}
      catch(error){setMiniStatus(error.message||miniCart.dataset.error);if(miniFallback)miniFallback.hidden=false}
    };
    const changeMiniCart=async(key,quantity,successMessage)=>{
      if(!miniCart||miniBusy)return;
      const nextQuantity=Math.max(0,Math.trunc(Number(quantity)||0));
      setMiniBusy(true);setMiniStatus(miniCart.dataset.updating);
      try{
        const root=window.Shopify?.routes?.root||'/';
        const response=await fetch(root+'cart/change.js',{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:nextQuantity})});
        const cart=await response.json();
        if(!response.ok)throw new Error(cart.description||cart.message||miniCart.dataset.error);
        renderMiniCart(cart);updateCartCounts(cart.item_count);setMiniStatus(successMessage);
      }catch(error){setMiniStatus(error.message||miniCart.dataset.error)}
      finally{setMiniBusy(false)}
    };
    miniTriggers.forEach((trigger)=>trigger.addEventListener('click',(event)=>{
      if(!miniCart||!miniPanel)return;
      if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      event.preventDefault();
      if(miniCart&&!miniCart.hidden){miniCart.querySelector('.mini-cart__close')?.focus();return}
      openMiniCart(trigger);
    }));
    miniCart?.querySelectorAll('[data-mini-cart-close]').forEach((control)=>control.addEventListener('click',()=>closeMiniCart(true)));
    miniBody?.addEventListener('click',(event)=>{
      const target=event.target;
      if(!target?.closest)return;
      const line=target.closest('[data-line-key]');
      if(!line)return;
      const quantityControl=target.closest('[data-mini-cart-quantity-change]');
      if(quantityControl){const input=line.querySelector('[data-mini-cart-quantity]');const next=Number(input?.value||0)+Number(quantityControl.dataset.miniCartQuantityChange||0);changeMiniCart(line.dataset.lineKey,next,next===0?miniCart.dataset.removed:miniCart.dataset.updated);return}
      if(target.closest('[data-mini-cart-remove]'))changeMiniCart(line.dataset.lineKey,0,miniCart.dataset.removed);
    });
    miniBody?.addEventListener('change',(event)=>{
      const input=event.target;
      if(!input?.matches?.('[data-mini-cart-quantity]'))return;
      const line=input.closest('[data-line-key]');
      const parsed=Number(input.value);
      if(input.value.trim()===''||!Number.isFinite(parsed)||parsed<0){input.value=input.dataset.currentQuantity;return}
      const next=Math.trunc(parsed);
      if(next===Number(input.dataset.currentQuantity))return;
      changeMiniCart(line.dataset.lineKey,next,next===0?miniCart.dataset.removed:miniCart.dataset.updated);
    });
    document.addEventListener('megakron:cart-added',()=>{if(miniCart&&!miniCart.hidden)closeMiniCart(false)});
    document.addEventListener('keydown',(event)=>{
      if(!miniCart||miniCart.hidden)return;
      if(event.key==='Escape'){event.preventDefault();closeMiniCart(true);return}
      if(event.key!=='Tab'||!miniPanel)return;
      const focusable=Array.from(miniPanel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')).filter((element)=>!element.closest('[hidden]'));
      if(!focusable.length){event.preventDefault();return}
      const first=focusable[0];const last=focusable[focusable.length-1];
      if(event.shiftKey&&(document.activeElement===first||!miniPanel.contains(document.activeElement))){event.preventDefault();last.focus()}
      else if(!event.shiftKey&&(document.activeElement===last||!miniPanel.contains(document.activeElement))){event.preventDefault();first.focus()}
    });
    notice?.querySelector('[data-cart-notice-close]')?.addEventListener('click',closeNotice);
    document.addEventListener('click',(event)=>{if(!notice||notice.hidden||notice.contains(event.target))return;closeNotice()});
    document.addEventListener('keydown',(event)=>{if(event.key==='Escape'&&notice&&!notice.hidden){closeNotice();notice.querySelector('[data-cart-notice-close]')?.focus()}});
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vehicle-finder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vehicle-finder]').forEach((root)=>{
    const data=root.querySelector('[data-finder-data]');
    let groups=[];
    try{groups=JSON.parse(data.textContent||'[]')}catch(error){groups=[]}
    const escapePattern=(value)=>value.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
    const rows=[];
    groups.forEach((group)=>{
      const match=String(group.group).match(/^(\d{4})(?:\s*[-–—]\s*(\d{4}))?\s+(.+)$/);
      if(!match)return;
      const start=Number(match[1]);
      const end=Number(match[2]||match[1]);
      const model=match[3].replace(new RegExp('^'+escapePattern(group.make)+'\\s+','i'),'').trim();
      if(!model||end<start||end-start>20)return;
      for(let year=start;year<=end;year+=1)rows.push({year:String(year),make:group.make,model,url:group.url,group:group.group})
    });
    const year=root.querySelector('[data-year]');
    const make=root.querySelector('[data-make]');
    const model=root.querySelector('[data-model]');
    const submit=root.querySelector('button[type="submit"]');
    const unique=(values)=>[...new Set(values)].sort((a,b)=>a.localeCompare(b,undefined,{numeric:true}));
    const fill=(select,values,label)=>{select.innerHTML='';const first=document.createElement('option');first.value='';first.textContent=label;select.append(first);values.forEach((value)=>{const option=document.createElement('option');option.value=value;option.textContent=value;select.append(option)});select.disabled=values.length===0};
    fill(year,unique(rows.map((row)=>row.year)),root.dataset.selectYear);
    submit.disabled=rows.length===0;
    year.addEventListener('change',()=>{fill(make,unique(rows.filter((row)=>row.year===year.value).map((row)=>row.make)),root.dataset.selectMake);fill(model,[],root.dataset.selectModel)});
    make.addEventListener('change',()=>fill(model,unique(rows.filter((row)=>row.year===year.value&&row.make===make.value).map((row)=>row.model)),root.dataset.selectModel));
    root.querySelector('[data-finder-form]').addEventListener('submit',(event)=>{event.preventDefault();const match=rows.find((row)=>row.year===year.value&&row.make===make.value&&row.model===model.value);window.location.href=match?.url||root.dataset.directoryUrl||'/pages/popular-vehicles'});
  });

  } catch(e) { console.error(e); }
})();
})();
